var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaskStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#d7d7e6",
    height: 24,
    rx: 2.74286,
    width: 24,
    x: 0.500092
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.50009 7h8.57143v8.57143h-8.57143z",
    fill: "#000",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11.389 11.324v1.3427h-2.49845c-.76491 0-1.39046.6218-1.39046 1.3889v1.3889h10.00001v-1.3889c0-.7724-.6226-1.3889-1.3905-1.3889h-2.4984v-1.3429c.9799-.4289 1.6667-1.40745 1.6667-2.54602 0-1.53094-1.2437-2.77778-2.7778-2.77778-1.531 0-2.77781 1.24367-2.77781 2.77778 0 1.13676.68561 2.11682 1.66671 2.54622zm5.5553 4.676h-8.88878-.00001v1.1111h8.88879z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskStop);
export default __webpack_public_path__ + "static/media/icon-task-stop.74e4c66ac80077b102acda5189b8f70e.svg";
export { ForwardRef as ReactComponent };